<app-breadcrumb></app-breadcrumb>
<div class="container">
     <div class="main-container-cache-viewer">
          <div class="category">{{category}}</div>
          <p-accordion>
               <p-accordionTab [header]="cache.key" *ngFor="let cache of cacheList; let i = index">
                    <div class="value-container">
                         <pre>
                             {{ cache.value }}
                         </pre>
                    </div>
               </p-accordionTab>
           </p-accordion>
</div>
